// extracted by mini-css-extract-plugin
export default {"coffeePromotionsPage":"style_coffeePromotionsPage__t6NXg"};